import { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Seo } from "../components/site/Seo";
import AdminDashboard from "./AdminDashboard";

export default function AdminPage() {
  const [auth, setAuth] = useState(null); // null=checking, false=login, object=authenticated
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then((r) => setAuth(r.data)).catch(() => setAuth(false));
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setAuth(data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (auth === null) {
    return <main className="min-h-screen bg-zinc-950 flex items-center justify-center text-zinc-500 text-sm" data-testid="admin-loading">Verificando sesión…</main>;
  }

  if (auth === false) {
    return (
      <main className="min-h-screen bg-zinc-950 flex items-center justify-center px-4" data-testid="admin-login-page">
        <Seo title="Administración — AZOO Costa Rica" description="Panel de administración de AZOO Costa Rica." />
        <div className="w-full max-w-sm bg-white rounded-2xl p-8 shadow-xl">
          <img src="/logo-azoo.png" alt="AZOO" className="h-9 w-auto mb-6" />
          <h1 className="text-xl font-black text-zinc-950" data-testid="admin-login-title">Panel de administración</h1>
          <p className="text-xs text-zinc-500 mt-1 mb-6">Inicia sesión para gestionar productos y artículos.</p>
          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-1.5">
              <label htmlFor="admin-email" className="text-xs font-bold text-zinc-700">Correo electrónico</label>
              <input
                id="admin-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2.5 rounded-lg border border-zinc-200 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500"
                data-testid="admin-email-input"
              />
            </div>
            <div className="space-y-1.5">
              <label htmlFor="admin-password" className="text-xs font-bold text-zinc-700">Contraseña</label>
              <input
                id="admin-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2.5 rounded-lg border border-zinc-200 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500"
                data-testid="admin-password-input"
              />
            </div>
            {error && <p className="text-xs font-semibold text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="admin-login-error">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full px-4 py-3 rounded-xl bg-brand-600 hover:bg-brand-500 disabled:opacity-60 text-white font-bold text-sm uppercase tracking-wider transition-colors"
              data-testid="admin-login-submit"
            >
              {loading ? "Ingresando…" : "Ingresar"}
            </button>
          </form>
        </div>
      </main>
    );
  }

  return <AdminDashboard auth={auth} onLogout={() => setAuth(false)} />;
}
